import { render } from "./SocialNetworkServiceParameter.vue?vue&type=template&id=69feac6b&scoped=true"
import script from "./SocialNetworkServiceParameter.vue?vue&type=script&lang=ts"
export * from "./SocialNetworkServiceParameter.vue?vue&type=script&lang=ts"

import "./SocialNetworkServiceParameter.vue?vue&type=style&index=0&id=69feac6b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-69feac6b"

export default script